import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Outlet } from "react-router-dom";

export default function Layout() {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    return (
        <div className="min-h-screen flex bg-[hsl(var(--bg))] overflow-x-hidden">
            <Sidebar mobileOpen={mobileNavOpen}
                       onMobileClose={() => setMobileNavOpen(false)} />
            <div className="flex-1 flex flex-col min-w-0">
                <Topbar onOpenMobileNav={() => setMobileNavOpen(true)} />
                <main className="flex-1 overflow-y-auto overflow-x-hidden">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
